import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import TableHeaders from "./TableHeaders";
import TableBody from "./TableBody";
import TableControls from "./TableControls";
import { withRouter } from "react-router";
import getPublishersList from "../api/getPublishersList";
import { useSelector } from "react-redux";
import Spinner from "./Spinner/Spinner";
// import { shortenTableEntry } from "../utils/formatter";

const PublishersTable = ({ history }) => {
  const col = [
    {
      Header: "ID",
      accessor: "id",
      columnType: "col-sm-1",
    },
    {
      Header: "Prefix",
      accessor: "prefix",
      columnType: "col-sm-1",
    },
    {
      Header: "Nazwa uż.",
      accessor: "username",
      columnType: "col-sm-1",
    },
    {
      Header: "Wydawca",
      accessor: "full_name",
      columnType: "col-sm-2",
      // Cell: ({ value }) => {
      //   return shortenTableEntry(value, 30);
      // },
    },
    {
      Header: "Email",
      accessor: "email",
      columnType: "col",
    },
    {
      Header: "Adres DHC",
      accessor: "public_address",
      columnType: "col",
    },
    // {
    //   id: "publisher-edit-button",
    //   columnType: "col",
    //   Header: "",
    //   accessor: "user_id",
    //   Cell: ({ value }) => {
    //     return (
    //       <div className="float-right" >
    //         <Button
    //           text="Edytuj"
    //           onClick={() => editPublisher(value)}
    //           styleOptions={{
    //             padding: "0.35rem 1rem",
    //             fontSize: "0.85rem",
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  const [publishers, setPublishers] = useState([]);
  const [loading, setLoading] = useState(true);
  const loggedUser = useSelector((state) => state.authentication.user);

  const getPublishers = async () => {
    let response;
    if (loggedUser.business_type === "audiobook_admin") {
      response = await getPublishersList();
    } else if (loggedUser.business_type === "publisher") {
      response = await getPublishersList(loggedUser.libAddress);
    }
    setPublishers(response);
    setLoading(false);
  };

  useEffect(() => {
    getPublishers();
  }, []);

  const columns = useMemo(() => col, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    pageOptions,
    state,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    prepareRow,
    gotoPage,
    pageCount,
  } = useTable(
    { columns, data: publishers, initialState: { pageSize: 16 }, autoResetSortBy: false },
    useSortBy,
    usePagination
  );
  const { pageIndex } = state;

  const publisherClicked = (publisherID) => {
    editPublisher(publisherID)
  };
  const editPublisher = (id) => {
    history.push(`/publishers/edit/${id}`);
  };

  return (
    <div
      className="container"
      {...getTableProps()}
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    >
      {!loading ?
        <>
          <TableHeaders headerGroups={headerGroups} />
          <TableBody
            {...getTableBodyProps()}
            rows={page}
            prepareRow={prepareRow}
            onClick={publisherClicked}
            maxHeight={"67vh"}
          />
          <TableControls
            pageOptions={pageOptions}
            nextPage={nextPage}
            previousPage={previousPage}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            pageIndex={pageIndex}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
        </>
        : <div style={{ textAlign: "-webkit-center" }}>
          <Spinner customStyles={{ fontSize: "30px", margin: "40px" }} />
        </div>
      }
    </div>
  );
};

export default withRouter(PublishersTable);
